<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-6,802.5c-1.92,0-3.5-1.58-3.5-3.5s1.58-3.5,3.5-3.5c0.6,0,1.16,0.17,1.65,0.44l1.64-1.64l-0.79-0.79h-2v-2h2l0.79-0.79
	l-1.64-1.64c-0.5,0.27-1.05,0.44-1.65,0.44c-1.92,0-3.5-1.58-3.5-3.5c0-1.92,1.58-3.5,3.5-3.5c1.92,0,3.5,1.58,3.5,3.5
	c0,0.6-0.17,1.15-0.43,1.65l1.64,1.64l0.79-0.79h2l0.79,0.79l1.64-1.64C3.67,787.15,3.5,786.6,3.5,786c0-1.92,1.58-3.5,3.5-3.5
	c1.92,0,3.5,1.58,3.5,3.5c0,1.92-1.58,3.5-3.5,3.5c-0.6,0-1.15-0.17-1.65-0.43l-1.64,1.64l0.79,0.79h2v2h-2l-0.79,0.79l1.64,1.64
	c0.49-0.27,1.05-0.43,1.65-0.43c1.92,0,3.5,1.58,3.5,3.5s-1.58,3.5-3.5,3.5c-1.92,0-3.5-1.58-3.5-3.5c0-0.6,0.17-1.16,0.44-1.65
	l-1.64-1.64L1.5,796.5h-2l-0.79-0.79l-1.65,1.64c0.27,0.49,0.44,1.05,0.44,1.65C-2.5,800.92-4.08,802.5-6,802.5L-6,802.5z M-6,800.5
	c0.84,0,1.5-0.66,1.5-1.5s-0.66-1.5-1.5-1.5c-0.84,0-1.5,0.66-1.5,1.5S-6.84,800.5-6,800.5z M7,800.5c0.84,0,1.5-0.66,1.5-1.5
	s-0.66-1.5-1.5-1.5c-0.84,0-1.5,0.66-1.5,1.5S6.16,800.5,7,800.5z M-6,787.5c0.84,0,1.5-0.66,1.5-1.5c0-0.84-0.66-1.5-1.5-1.5
	c-0.84,0-1.5,0.66-1.5,1.5C-7.5,786.84-6.84,787.5-6,787.5z M7,787.5c0.84,0,1.5-0.66,1.5-1.5c0-0.84-0.66-1.5-1.5-1.5
	c-0.84,0-1.5,0.66-1.5,1.5C5.5,786.84,6.16,787.5,7,787.5z"/>
</svg>

</template>